<template>
    <VideoJsPlayer :sourceUrl="source" :autoplay="autoplay" :type="`video/mp4`"/>
</template>

<script>
    import VideoJsPlayer from './VideoJsPlayer'

    export default {
        components: {
            VideoJsPlayer,
        },

        props: {
            video: { type: Object, required: true },
            autoplay: { type: Boolean, default: false },
        },

        data() {
            const cacheTimestamp = new Date().getTime()
            return { cacheTimestamp }
        },

        computed: {
            source() {
                return this.video.video_host_id
            },
        },
    }
</script>